<template>
  <h1 v-if="hasError">Error Occured</h1>
  <h1 v-else-if="isLoading">Loading...</h1>

  <div v-else>
    <div class="searchBarContainer">
      <input
        class="searchInput"
        v-model="searchText"
        type="text"
        placeholder="Search for a Country"
      />
      <select class="dropDown" v-model="region">
        <option value="all">Filter by Region</option>
        <option value="Africa">Africa</option>
        <option value="Americas">Americas</option>
        <option value="Asia">Asia</option>
        <option value="Europe">Europe</option>
        <option value="Oceania">Oceania</option>
      </select>
    </div>
    <div class="contentPage">

      
      <div
        v-for="eachCountryData in allCountries"
        :key="eachCountryData.cca3"
      >
       <router-link :to="`/${eachCountryData.cca3}`" >
       <div class="eachCountryData">
        <img
          :src="eachCountryData.flags.png"
          alt="country-pic"
          class="countryPhoto"
        />
        <ul>
          <li class="countryName">{{ eachCountryData.name.common }}</li>
          <li>
            <label>Population:{{ eachCountryData.population }}</label>
          </li>
          <li>
            <label>Region:{{ eachCountryData.region }}</label>
          </li>
          <li v-if="eachCountryData.capital">
            <label>Capital:{{ eachCountryData.capital[0] }}</label>
          </li>
        </ul>
       </div>
       </router-link>
      </div>
       
    

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allCountries: [],
      allCountriesData: [],
      searchText: "",
      region: "all",
      isLoading: true,
      hasError: false,
    };
  },
  created() {
    // fetch on init
    this.fetchAllCountry();
  },
  beforeUpdate() {
    //console.log(this.searchText, this.region)

    const searchResults =
      this.searchText === ""
        ? this.allCountriesData
        : this.allCountriesData.filter((eachCountryData) => {
            const searchTextLength = this.searchText.length;
            return (
              eachCountryData.name.common
                .slice(0, searchTextLength)
                .toLowerCase() === this.searchText.toLowerCase()
            );
          });

    this.allCountries =
      this.region === "all"
        ? searchResults
        : searchResults.filter((eachCountryData) => {
            return eachCountryData.region === this.region;
          });
  },

  methods: {
    async fetchAllCountry() {
      try {
        
        const data = await fetch("https://restcountries.com/v3.1/all").then(
          (res) => res.json()
        )
        
        this.allCountries = data;
        this.allCountriesData = data;
        this.isLoading = false;
        this.hasError = false;
       
      } catch (err) {
        console.log("in catch");
        this.isLoading = false;
        this.hasError = true;
      }

     
    },
  },
};
</script>

<style>
.searchBarContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  width: 100%;
}

.searchInput {
  height: 25px;
  width: 15rem;
  margin-left: 4.7rem;
}
.dropDown {
  margin-right: 5rem;
  height: 40px;
  width: 160px;
  font-weight: 600;
  text-align: center;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 1px #ccc;
}
.contentPage {
  display: flex;
  flex-wrap: wrap;
  background-color: hsl(0, 0%, 95%);
  margin: 0 2.7rem;
}

.eachCountryData {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 2rem;
  border: 0.1px solid hsl(0, 0%, 60%);
  border-radius: 5px;
  background-color: white;
}
ul {
  list-style-type: none;
  margin-block-end: 0;
  padding-inline-start: 0;
  margin: 1rem 0 2rem 0;
}
li {
  margin: 0.5rem 0;
  font-weight: 300;
}
.countryName {
  font-size: 20px;
  font-weight: 500;
}

.countryPhoto {
  height: 100px;
  width: 230px;
}
</style>